import React from "react";
import { PalletDetail } from "../../../types/palletDetail";
import { DefectType } from "../../../types/defectType";
import { renderSingleDefectName } from "../../../aplUtils/defectsHelper";
import { renderPalletStatus } from "../../../aplUtils/statusConditionEnumHelper";
import { translateString } from "../../../translations/gridTranslationHelper";
import { Culture } from "../../../types/culture";

export default function ModalConsumptionIssuingPalletStatus(props: { pallet: PalletDetail; defectTypes: DefectType[]; culture: Culture }) {
    return (
        <React.Fragment>
            <div>
                <b>
                    {translateString("palletStatus", props.culture)}: {renderPalletStatus(props.pallet.statusId, props.culture)}
                </b>
            </div>
            {props.pallet.defects.length > 0 && [5, 10, 12].includes(props.pallet.statusId) && (<div>&nbsp;</div>)}

            {[5, 10, 12].includes(props.pallet.statusId) && (
                <table className="table-modal" style={{ display: "table", minWidth: '100%' }}>
                    <thead>
                        <tr>
                            <th scope="col">{translateString("rxg_defectsTable_Defect", props.culture)}</th>
                            <th scope="col">{translateString("mouldNo", props.culture)}</th>
                            <th scope="col">{translateString("rxg_defectsTable_Comment", props.culture)}</th>
                            <th scope="col">{translateString("rxg_defectsTable_Initials", props.culture)}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.pallet.defects.map(defect => (
                            <tr key={`${props.pallet.palletId}-${defect.defectId}-${defect.mouldNo}`}>
                                <td>{renderSingleDefectName(defect.defectId, props.defectTypes)}</td>
                                <td>{defect.mouldNo}</td>
                                <td>{defect.comment}</td>
                                <td>{defect.initials}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </React.Fragment>
    );
}
